import React from 'react';

import { getBrandName } from '../brand-name';
import { Seo } from './Seo';
import { SeoChesnok } from './SeoChesnok';

export function getBrandSEO() {
  const brandName = getBrandName();

  switch (brandName) {
    case 'tennisi':
      return <Seo />;
    case 'chesnok':
      return <SeoChesnok />;
    // TODO: KOMYOB
    case 'komyob':
      return <Seo />;
    default:
      assertExhaustiveness(brandName);
  }
}
